import React from "react";
import PropTypes from "prop-types";
import { List } from "semantic-ui-react";

const ListItems = ({ listItem, url }) => (
  <List as="ol">
    {listItem.map((list, index) => (
      <List.Item key={index}>
        <a href={url} title={url}>{list}</a>
      </List.Item>
    ))}
  </List>
);

ListItems.propTypes = {
  listItem: PropTypes.array.isRequired,
};

export default ListItems;
